import * as React from "react";

import { StaticGridModelTransformersDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: StaticGridModelTransformersDto;
    left: number;
}

const Row = ({ dto, left }: OwnProps) =>
    <tr>
        <td>{dto.node1Country}</td>
        <td className="lineLeft">{dto.node1Name}</td>
        <td>{dto.node2Name}</td>
        <td>{dto.node1UctName}</td>
        <td>{dto.node2UctName}</td>
        <td>{dto.orderCode}</td>
        <td className="lineLeft">{dto.voltage1}</td>
        <td>{dto.voltage2}</td>
        <td>{dto.nominalPower}</td>
        <td className="lineLeft">{dto.resistance}</td>
        <td>{dto.reactance}</td>
        <td>{dto.susceptance}</td>
        <td>{dto.conductance}</td>
    </tr>;

export default Row;